import { weekDayToNumber } from "../constants/weekDayToNumber";

const ISO_TO_WEEKDAY_SHORT = Object.fromEntries(
    Object.entries(weekDayToNumber).map(([short, iso]) => [iso, short])
);

export const MAX_SCHEDULE_DURATION_DAYS = 366;

export const SCHEDULE_PERIOD_PRESETS = [
    { id: "week1", label: "Неделя", days: 7 },
    { id: "week2", label: "2 недели", days: 14 },
    { id: "month", label: "Месяц", months: 1 },
    { id: "quarter", label: "Квартал", months: 3 },
    { id: "half", label: "Полгода", months: 6 },
    { id: "year", label: "Год", months: 12 },
];

export function endDateFromStartAndDuration(startDate, durationDays) {
    return startDate.clone().add(durationDays - 1, "days");
}

export function durationDaysFromRange(startDate, endDate) {
    return endDate.diff(startDate, "days") + 1;
}

export function endDateFromPreset(startDate, preset) {
    const start = startDate.clone().startOf("day");
    if (preset.days) {
        return start.clone().add(preset.days - 1, "days");
    }
    if (preset.months) {
        return start.clone().add(preset.months, "months").subtract(1, "day");
    }
    return start.clone();
}

export function detectActivePreset(startDate, endDate) {
    const start = startDate.clone().startOf("day");
    const end = endDate.clone().startOf("day");

    for (const preset of SCHEDULE_PERIOD_PRESETS) {
        const expectedEnd = endDateFromPreset(start, preset);
        if (end.isSame(expectedEnd, "day")) {
            return preset.id;
        }
    }
    return null;
}

export function countLessonsInPeriod(startDate, endDate, selectedWeekdayShorts) {
    if (!selectedWeekdayShorts?.length) {
        return 0;
    }

    const selectedSet = new Set(selectedWeekdayShorts);
    let count = 0;
    const current = startDate.clone().startOf("day");
    const last = endDate.clone().startOf("day");

    while (current.isSameOrBefore(last, "day")) {
        const short = ISO_TO_WEEKDAY_SHORT[current.isoWeekday()];
        if (selectedSet.has(short)) {
            count += 1;
        }
        current.add(1, "day");
    }

    return count;
}

export function lessonsCountLabel(count, t = (value) => value) {
    const lastTwo = count % 100;
    const lastOne = count % 10;

    if (lastTwo >= 11 && lastTwo <= 14) {
        return t("{{count}} занятий", { count });
    }
    if (lastOne === 1) {
        return t("{{count}} занятие", { count });
    }
    if (lastOne >= 2 && lastOne <= 4) {
        return t("{{count}} занятия", { count });
    }
    return t("{{count}} занятий", { count });
}

export function getPresetById(presetId) {
    return SCHEDULE_PERIOD_PRESETS.find((preset) => preset.id === presetId) || null;
}
